import { PropsWithChildren, useMemo } from "react"
import { createContext, useContextSelector } from "use-context-selector"
import { ListOptions } from "@tm/models"
import { ensureContextAvailability } from "../../helpers"
import { useListOptions } from "./useListOptions"
import { useErpInfosContext } from ".."

export const ListOptionsContext = createContext<ListOptions | undefined>(undefined)

export function ListOptionsProvider(props: PropsWithChildren<unknown>) {
    const listOptions = useListOptions()
    const { isNoTeccomRequestAvailable } = useErpInfosContext()

    const mergedListOptions = useMemo(() => {
        return { ...listOptions, isNoTeccomRequestAvailable }
    }, [isNoTeccomRequestAvailable, listOptions])

    return <ListOptionsContext.Provider value={mergedListOptions}>{props.children}</ListOptionsContext.Provider>
}

export function useListOptionsContext(): ListOptions
export function useListOptionsContext<T>(selector: (ctx: ListOptions) => T): T
export function useListOptionsContext<TReturn = ListOptions>(selector?: (ctx: ListOptions) => TReturn): TReturn | ListOptions {
    return useContextSelector(ListOptionsContext, (context) => {
        const validatedContext = ensureContextAvailability("ListOptionsContext", context)

        if (!selector) {
            return validatedContext
        }

        return selector(validatedContext as ListOptions)
    })
}
